import { useQuery } from '@tanstack/react-query';
import { occerSearchApi } from '@/api/occerSearchApi';

export const OCCER_SEARCH_STAFF_KEY = ['occer-search', 'staff'];
export const OCCER_SEARCH_DASHBOARD_KEY = ['occer-search', 'dashboard'];

export function useActiveStaff(excludePartners = false) {
  return useQuery({
    queryKey: [...OCCER_SEARCH_STAFF_KEY, { excludePartners }],
    queryFn: () => occerSearchApi.getActiveStaff(excludePartners),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}

export function useEmployeeDashboard(employeeId: number | null) {
  return useQuery({
    queryKey: [...OCCER_SEARCH_DASHBOARD_KEY, employeeId],
    queryFn: () => occerSearchApi.getEmployeeDashboard(employeeId!),
    enabled: employeeId !== null,
  });
}
